import './js/lightbox';
import './js/share';
